import { MyNaviFilterLayout } from '@/components/Campaign/mynavi/MyNaviModels/Filter/MyNaviFilterLayout'
import { useApi } from '@/core/api/useApi'
import { IconSquareCheck, IconSquareCheckFilled } from '@tabler/icons-react'
import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'

const FONT_STYLE = { fontFamily: "'BIZ UDPGothic', sans-serif" }

function CheckboxIcon({ checked }: { checked: boolean }) {
  return checked ? (
    <IconSquareCheckFilled size={16} color="#058bbe" className="flex-shrink-0" />
  ) : (
    <IconSquareCheck size={16} color="#686868" strokeWidth={1.5} className="flex-shrink-0" />
  )
}

type CollegeType = { value: string; label: string }

type Props = {
  initialCollegeTypes: string[]
  onSelect: (collegeTypes: string[]) => void
  onClear: () => void
  onClose: () => void
  collegeTypes?: CollegeType[]
}

export function FilterSchoolType({
  initialCollegeTypes,
  onSelect,
  onClear,
  onClose,
  collegeTypes: collegeTypesProp,
}: Props) {
  const api = useApi()

  const [localSelected, setLocalSelected] = useState<string[]>(initialCollegeTypes)

  const { data: collegeTypesData } = useQuery({
    queryKey: ['mynavi-college-types'],
    queryFn: () => api.guest.fetchMynaviCollegeTypes(),
    staleTime: 5 * 60 * 1000,
    enabled: collegeTypesProp === undefined,
  })

  const { data: countData } = useQuery({
    queryKey: ['mynavi-filter-count', 'school-type', localSelected],
    queryFn: () => api.guest.fetchMynaviCollegesFilterCount({ collegeTypes: localSelected }),
    staleTime: 30 * 1000,
    enabled: collegeTypesProp === undefined,
  })

  const resolvedCollegeTypes: CollegeType[] = collegeTypesProp ?? collegeTypesData?.collegeTypes ?? []

  const handleToggle = (value: string) => {
    setLocalSelected((prev) => (prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]))
  }

  const handleSelect = () => {
    onSelect(localSelected)
  }

  const handleClear = () => {
    setLocalSelected([])
    onClear()
  }

  return (
    <MyNaviFilterLayout
      title="学校種別を選択する"
      onClose={onClose}
      searchResultCount={countData?.count ?? null}
      onSelect={handleSelect}
      onClear={handleClear}
    >
      <div className="flex flex-col">
        {resolvedCollegeTypes.map((item) => (
          <button
            key={item.value}
            type="button"
            onClick={() => handleToggle(item.value)}
            className="flex items-center justify-between h-[38px] px-[17px] bg-[#f8f8f8] border-b border-[#e5e5e5]"
          >
            <span className="text-[#686868] text-[14px]" style={FONT_STYLE}>
              {item.label}
            </span>
            <CheckboxIcon checked={localSelected.includes(item.value)} />
          </button>
        ))}
      </div>
    </MyNaviFilterLayout>
  )
}
